module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.amount)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_amount"
    }
  }, [_vm._v("Kwota")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.currencyName
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.amount),
      expression: "item.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": "_amount"
    },
    domProps: {
      "value": (_vm.item.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "amount", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors && _vm.errors.amount) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_amount_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.amount))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'form-group col col-md-6': true, 'has-error': (_vm.errors && _vm.errors.paymentDate)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_paymentDate"
    }
  }, [_vm._v("Data płatności")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "id": "_paymentDate",
      "type": "date",
      "placeholder": ""
    },
    model: {
      value: (_vm.item.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.item, "paymentDate", $$v)
      },
      expression: "item.paymentDate"
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.paymentDate) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_paymentDate_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.paymentDate))]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0133826a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/FormPayment.vue
// module id = 773
// module chunks = 0